import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';

import { Observable, Subject, timer } from 'rxjs';
import { map, startWith, switchMap, take, takeUntil } from 'rxjs/operators';
import { SessionTimeOutContent } from './models/session-time-out.interface';

@Component({
  selector: 'idp-session-time-out',
  templateUrl: './session-time-out.component.html',
  standalone: true,
  styleUrls: ['./session-time-out.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule]
})
export class SessionTimeOutComponent implements AfterViewInit, OnDestroy {
  @Input() sessionTimeOutContent: SessionTimeOutContent =
    {} as SessionTimeOutContent;

  @ViewChild('sessionTimeoutModal') sessionTimeoutModal!: ElementRef;
  @Output() logout = new EventEmitter();
  @Output() keepMeLoggedIn = new EventEmitter();
  timer$ = new Observable<string>();
  reset$ = new Subject();
  private destroy$ = new Subject<void>();

  ngAfterViewInit(): void {
    this.sessionTimeoutModal.nativeElement.showModal();
    this.timer$ = this.reset$.pipe(
      startWith(0),
      switchMap(() =>
        timer(0, 1000).pipe(
          take(this.sessionTimeOutContent.expiryTime),
          map((elapsedTime) => {
            const time =
              this.sessionTimeOutContent.expiryTime - 1 - elapsedTime;
            if (time === 0) {
              this.logout.emit();
            }
            return this.setTimer(time);
          }),
          takeUntil(this.destroy$)
        )
      )
    );
  }

  logMeOut(): void {
    this.sessionTimeoutModal.nativeElement.close();
    this.logout.emit();
  }

  extendMySession(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.sessionTimeoutModal.nativeElement.close();
    this.keepMeLoggedIn.emit();
  }

  setTimer(time: number): string {
    const minutes = Math.floor(time / 60);
    const seconds = String(time - minutes * 60).padStart(2, '0');
    const minutesText = minutes === 1 ? 'Min' : 'Mins';
    const secondsText = seconds === '00' ? 'Sec' : 'Secs';
    const expireTime = `${minutes} ${minutesText} ${seconds} ${secondsText}`;
    return expireTime;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
